module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("cDjTH"))).then(() => parcelRequire('3a9aZ'));